import classNames from "classnames/bind";

import styles from "./DragUploadImage.module.css";
import { useEffect, useState } from "react";
import Loading from "../Loading";
import { Close, CloseIcon } from "../Icons/Icons";
import { formatDateToTime } from "../../utils";
const cx = classNames.bind(styles)
function PreviewImage({ previewImage, previewOpen, setPreviewOpen, setPreviewImage, infoLisence }) {
    const [loading, setLoading] = useState(true)
    useEffect(() => {
        const timeout = setTimeout(() => {
            setLoading(false)
        }, 500)
        return () => clearTimeout(timeout)
    }, [])
    const handleClickClose = () => {
        setPreviewOpen(false)
        setPreviewImage()
    }
    return (
        <div className={cx('image-modal')} onClick={handleClickClose}>
            <div className={cx('header')}>
                <div className={cx('close-btn')} onClick={handleClickClose}>
                    <Close color={"#fff"} />
                </div>
            </div>
            <div className={cx('content')}>
                <div className={cx("wrapp_image")}>
                    <img
                        className={cx("image_preview")}
                        src={previewImage}
                    />
                    {infoLisence && (
                        <div className={cx('lisence_info')}>
                            <p>Biển số: {infoLisence?.license_plate?.split(": ")[1] || infoLisence?.license_plate || ''}</p>
                            <p>Thời gian: {formatDateToTime(infoLisence?.time) || ''}</p>
                            <p>Loại xe: {infoLisence?.object}</p>
                        </div>
                    )}
                    {loading && <div className={cx('loading-preview')}><Loading /></div>}
                </div>
            </div>
        </div>
    )
}

export default PreviewImage;